module.exports = __webpack_public_path__ + "media/images/lb/306-7349b14439c651ade57ce36d308ec37b.svg";